"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import { Dispatcher } from 'flux';

var AppDispatcherClass =
/*#__PURE__*/
function (_Dispatcher) {
  _inherits(AppDispatcherClass, _Dispatcher);

  function AppDispatcherClass() {
    _classCallCheck(this, AppDispatcherClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppDispatcherClass).apply(this, arguments));
  }

  _createClass(AppDispatcherClass, [{
    key: "asyncDispatch",
    value: function asyncDispatch() {
      var _this = this,
          _arguments = arguments;

      setTimeout(function () {
        return _get(_getPrototypeOf(AppDispatcherClass.prototype), "dispatch", _this).apply(_this, _arguments);
      });
    }
  }]);

  return AppDispatcherClass;
}(Dispatcher);

export var AppDispatcher = new AppDispatcherClass();